import DropZone from "@design-system/Inputs/DropZone";
import { Text } from "@design-system/Typography/Text";
import { useAtomValue } from "jotai";
import { Trans, useTranslation } from "react-i18next";
import { newS3FilesAtom } from "./DocumentsUploadModalContext";
import "./i18n";
import { useModalActions } from "./useModalActions";

export const DocumentsUploadModalDropzone = () => {
    const { t } = useTranslation("DocumentsUploadModal");
    const { handleDropFiles, isUploading } = useModalActions();
    const newS3Files = useAtomValue(newS3FilesAtom);

    return (
        <DropZone
            buttonText={t("dropzone_button")}
            multiple
            onChange={handleDropFiles}
            size={!!newS3Files.length || isUploading ? "md" : "lg"}
        >
            <Text as="span">
                <Trans t={t} i18nKey={"dropzone_title"} />
            </Text>
        </DropZone>
    );
};
